import React from 'react';
import { GuidePanel, SubHeading, Note } from '../GuidePanel';
import { ValidationSummary } from '../ValidationBadge';
import { QuestBlock } from '../quest/QuestBlock';
import { useNpcLocation } from '../../../hooks/useNpcLocation';
import { npcLocationValidation } from '../../../utils/npcLocation';
import { sebina } from '../../../data/guide/evolutions';
import { questTitle } from '../../../data/guide/quests';
import type { Checklist } from '../../../hooks/useChecklist';
import type { WorldLookup } from '../../../utils/progressionLookup';
import type { CharacterClass } from '../../../types/progression';
type Props = {
  cls?: CharacterClass;
  list: Checklist;
  lookup?: WorldLookup;
  status: string;
};

/** Segunda clase mediante Sebina: misiones 0 y 1 de los archivos exportados. */
export function SebinaSection({
  cls,
  list,
  lookup,
  status
}: Props) {
  const npcLoc = useNpcLocation('sebina');
  const npcRow = npcLoc ? npcLocationValidation(npcLoc) : {
    status: 'pendiente' as const,
    detail: ''
  };
  if (cls && !cls.second) {
    return <GuidePanel id="sebina" eyebrow="Segunda clase" title="Misión de Sebina" data-id="element-794" data-mp="3hc61hsiyeu0k">
        <Note tone="warn" data-id="element-795" data-mp="3cembxwgt2utb">
          <strong className="text-white" data-id="element-796" data-mp="3cectcty3bpxn">{cls.base} no realiza esta misión.</strong> Tiene un recorrido distinto y no necesita los objetos de Sebina. Su siguiente paso es la{' '}
          <a href="#tercera" className="font-semibold text-[#D4AF37] underline underline-offset-4" data-id="element-797" data-mp="33khqjskfybl6">tercera evolución ({cls.third})</a>, con una regla de inicio propia.
        </Note>
      </GuidePanel>;
  }
  return <GuidePanel id="sebina" eyebrow="Segunda clase" title="Misión de Sebina" data-id="element-798" data-mp="2tls6pu8zih2a">
      <ValidationSummary rows={[{
      label: 'Nivel, Zen, misión previa y clases',
      status: 'documentado',
      detail: 'Confirmado por la configuración exportada (quest_rules, quest_rule_classes)'
    }, {
      label: 'Objetos y cantidades',
      status: 'documentado',
      detail: 'quest_objectives y quest_objective_classes'
    }, {
      label: 'Dónde se obtienen los objetos',
      status: 'documentado',
      detail: 'Drops de misión con monstruos y mapas; requieren la misión aceptada'
    }, {
      label: 'Ubicación de Sebina',
      ...npcRow
    }, {
      label: 'Prueba dentro del juego',
      status: 'sin-probar'
    }]} data-id="element-799" data-mp="2oos11kg1rgbp" />

      <div id="sebina-1" className="scroll-mt-28 space-y-3" data-id="element-800" data-mp="23azxg31r3kff">
        <SubHeading data-id="element-801" data-mp="27fhc5nt977jc">{questTitle(0)}</SubHeading>
        <QuestBlock questId={0} cls={cls} list={list} prefix="sebina-0" lookup={lookup} status={status} steps={sebina.stepsPart1} data-id="element-802" data-mp="2v48za0rzkzp9" />
      </div>
      <div id="sebina-2" className="scroll-mt-28 space-y-3" data-id="element-803" data-mp="302aiclpewz0q">
        <SubHeading data-id="element-804" data-mp="2m3kgytvk8d6k">{questTitle(1)}</SubHeading>
        <QuestBlock questId={1} cls={cls} list={list} prefix="sebina-1" lookup={lookup} status={status} steps={sebina.stepsPart2} data-id="element-805" data-mp="2m2snpppfqrjg" />
      </div>
      <Note data-id="element-806" data-mp="1aof3qvxsyw8p">
        Al terminar las dos partes de Sebina se completa la evolución a segunda clase. Las misiones de{' '}
        <a href="#marlon" className="font-semibold text-[#D4AF37] underline underline-offset-4" data-id="element-807" data-mp="1fo1i58pdaij3">Marlon</a> son posteriores e independientes de ese cambio de clase.
      </Note>

      <SubHeading data-id="element-808" data-mp="134wew91vo8s7">Dudas habituales</SubHeading>
      <ul className="space-y-2 text-sm text-gray-300" data-id="element-809" data-mp="133utpbr5e5wr">
        {sebina.issues.map(t => <li key={t} className="rounded-xl border border-white/5 p-3" data-id="element-810" data-mp="1h4xe7k2hv85k">{t}</li>)}
      </ul>
    </GuidePanel>;
}